<template lang="pug">
#bloco-lista-certificacao-ativa
    el-card.lista-certificacao-ativa__card
        el-form.lista-certificacao-ativa__formulario
            .lista-certificacao-ativa__titulo
                p Selecione as certificações que deseja analisar

            .lista-certificacao-ativa__checkbox
                el-checkbox-group.certificacoes-ativas__opcoes(
                    v-model='certificacaoSelecionada',
                    v-loading='carregandoCertificacao'
                )
                    el-checkbox#certificacao-ativa-checkbox(
                        v-for='ativa in ativas',
                        :label='ativa.nome',
                        :key='ativa.nome + ativa.id',
                        :value='ativa.id',
                        @change='adicionarCertificacao'
                    ) {{ ativa.nome }}
</template>
<script>
import CertificacaoService from '@/services/CertificacaoService';
export default {
    name: 'BlocoListarAtivasCertificao',

    components: {
        CertificacaoService
    },

    props: {
        checkedDefaultByName: []
    },

    watch: {
        checkedDefaultByName: function () {
            this.buscarCertificacaoAtiva();
        }
    },

    data() {
        return {
            certificacaoSelecionada: [],
            carregandoCertificacao: false,
            ativas: [],
            isChecked: true
        };
    },
    mounted() {
        this.buscarCertificacaoAtiva();
    },
    methods: {
        async buscarCertificacaoAtiva() {
            try {
                this.carregandoCertificacao = true;
                const { data } =
                    await CertificacaoService.buscarTipoCertificacao();
                this.ativas = data.itens;
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível buscar os tipos de certificações'
                });
            }
            this.checkedPorDefault();
            this.carregandoCertificacao = false;
        },

        adicionarCertificacao() {
            const idsCertificacaoTipo = {
                idsTipo: this.obterIdsCertificacaoAtiva()
            };
            this.$emit('emitIdsCertificacaoTipo', idsCertificacaoTipo);
        },

        obterIdsCertificacaoAtiva() {
            if (!this.certificacaoSelecionada) return [];
            return this.certificacaoSelecionada.map(nome => {
                const statusObjeto = this.ativas.find(
                    objeto => objeto.nome === nome
                );
                return statusObjeto ? statusObjeto.id : null;
            });
        },

        checkedPorDefault() {
            const nomeObjeto = this.ativas.map(objeto => objeto.nome);

            if (Array.isArray(this.checkedDefaultByName)) {
                this.certificacaoSelecionada = this.checkedDefaultByName;
            } else {
                this.certificacaoSelecionada = nomeObjeto;
            }
            this.adicionarCertificacao();
        }
    }
};
</script>
<style lang="scss">
body {
    overflow-y: hidden;
    overflow-x: hidden;
}
#bloco-lista-certificacao-ativa {
    el-form.lista-certificacao-ativa__formulario {
        display: flex;
        flex-direction: column;

        .lista-certificacao-ativa__checkbox {
            display: flex;

            .certificacoes-ativas__opcoes {
                gap: 10px;
            }
        }
    }

    .el-checkbox-group.certificacoes-ativas__opcoes {
        display: flex;
        gap: 20px;
    }
}
</style>
